import { isMaterialUnitKg } from "./materialUnits";

export const MAX_MATERIAL_PROPERTY_PAIRS = 30;
export const MAX_MATERIAL_PROPERTY_KEY_LEN = 80;
export const MAX_MATERIAL_PROPERTY_VALUE_LEN = 300;

/** Ключ у propertyPairs для кг/м.п. (техкарти, тканина на складі в кг). */
export const MATERIAL_PROPERTY_KEY_KG_PER_LM = "вага 1 м.п.";

const MATERIAL_PROPERTY_KEYS_BASE = [
    { value: "Розмір", label: "Розмір" },
    { value: "Тип", label: "Тип" },
    { value: "Вага", label: "Вага" },
    /** Метрів на бобіну; при закупівлі в «бобінах» на склад зараховується бобіни × намотка (од. м). */
    { value: "Намотка", label: "Намотка" },
];

/**
 * Опції селекта ключа властивості. «Вага 1 м.п.» — лише для тканини (FABRIC) в кг.
 */
export function getMaterialPropertyKeySelectOptions(category, unit) {
    const opts = [...MATERIAL_PROPERTY_KEYS_BASE];
    if (String(category || "") === "FABRIC" && isMaterialUnitKg(unit)) {
        opts.push({ value: MATERIAL_PROPERTY_KEY_KG_PER_LM, label: "Вага 1 м.п." });
    }
    return opts;
}

/**
 * Нормалізація для PATCH/POST: унікальні ключі (без урахування регістру), порожні ключі відкидаються.
 */
export function normalizePropertyPairsPayload(rows) {
    if (!Array.isArray(rows)) {
        return [];
    }
    const out = [];
    const seen = new Set();
    for (const row of rows) {
        const k = String(row?.key ?? "")
            .trim()
            .slice(0, MAX_MATERIAL_PROPERTY_KEY_LEN);
        const v = String(row?.value ?? "")
            .trim()
            .slice(0, MAX_MATERIAL_PROPERTY_VALUE_LEN);
        if (!k) {
            continue;
        }
        const kl = k.toLowerCase();
        if (seen.has(kl)) {
            continue;
        }
        seen.add(kl);
        out.push({ key: k, value: v });
        if (out.length >= MAX_MATERIAL_PROPERTY_PAIRS) {
            break;
        }
    }
    return out;
}

export function materialPropertyPairsSummary(pairs) {
    if (!Array.isArray(pairs) || pairs.length === 0) {
        return "";
    }
    return pairs.map((p) => `${p.key}: ${p.value || "—"}`).join(" · ");
}

export function materialPropertyPairsSearchBlob(pairs) {
    if (!Array.isArray(pairs) || pairs.length === 0) {
        return "";
    }
    return pairs
        .map((p) => `${p.key} ${p.value}`)
        .join(" ")
        .toLowerCase();
}
